import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaClock, FaMapMarkerAlt, FaHeadset } from "react-icons/fa";

import "./contact.css";
import Header from "../../component/header/header";
import Footer from "../../component/footer/footer";
import Form from "../../component/form/form";

const Contact = () => {
  return (
    <div className="contact-section">
      {/* header */}
      <Header />

      <div className="mt-5">
        <motion.h2
          className="contact-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Contact
        </motion.h2>

        <Container className="mt-4">
          <Row className="text-center gy-5">
            {/* --- OPEN HOURS --- */}
            <Col md={4}>
              <motion.div
                className="contact-box"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <FaClock className="contact-icon" />
                <h4 className="box-title">Open Hours</h4>
                <p>Mon–Fri: 9 AM – 6 PM</p>
                <p>Saturday: 9 AM – 4 PM</p>
                <p>Sunday: Closed</p>
              </motion.div>
            </Col>

            {/* --- ADDRESS --- */}
            <Col md={4}>
              <motion.div
                className="contact-box"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <FaMapMarkerAlt className="contact-icon" />
                <h4 className="box-title">Address</h4>

                <p>211 - A Silver Square, Opp Baghban Party<br/> Plot, Thaltej-Shilaj Road, Ahmedabad 380059</p>

              </motion.div>
            </Col>

            {/* --- GET IN TOUCH --- */}
            <Col md={4}>
              <motion.div
                className="contact-box"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                <FaHeadset className="contact-icon" />
                <h4 className="box-title">Get In Touch</h4>

                {/* CLICK-TO-CALL */}
                <p>
                  Telephone:{" "}
                  <a className="phone-link" href="tel:+18001234566">
                    +91 70169 29807
                  </a>
                </p>

                {/* CLICK-TO-EMAIL */}
                <p>
                  Email:{" "}
                  <a className="phone-link" href="mailto:sales@starlighttechlabs.com">
                   sales@starlighttechlabs.com
                  </a>
                </p>

              
              </motion.div>
            </Col>
          </Row>
        </Container>

        {/* secound section */}
        <div className="hero-section mt-5 mb-5">
          <div className="overlay"></div>

          <Container className="text-center hero-content">
            {/* Small Title */}
            

            {/* Main Heading */}
            <motion.h1
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.2 }}
              className="hero-title"
            >
              Your results are our <br /> top priority!
            </motion.h1>

           
          </Container>
        </div>
        {/* form */}
        <Form />

        {/* map */}
        <div className="mt-5 mb-5">
          <motion.div
            className="map-fullscreen-wrapper"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            <iframe
              title="Full Screen Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.286205737147!2d72.49581850969756!3d23.04996651522061!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e9b51f008bca3%3A0x73919050103ecdcd!2sStarlight%20Tech%20Labs!5e0!3m2!1sen!2sin!4v1764744124020!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="fullscreen-map"
            ></iframe>
          </motion.div>
        </div>
      </div>
      {/* footer */}
      <Footer />
    </div>
  );
};

export default Contact;
